
import { configureStore } from '@reduxjs/toolkit';
import { reducer as formReducer } from "redux-form";
import { setupListeners } from '@reduxjs/toolkit/query';
import { getConfigApi } from '../services/getConfigurations';
import { getChemicalsApi} from '../services/loadChemicals';
import { getStyleNumbersApi} from '../services/loadStyleNumbers';
import { getPermeationsApi} from '../services/getPermeations';
import { glovesSelectorReducer } from "./reducers";
import { facetApi } from '../services/getFacets';
import { infoAreaApi } from '../services/getInfoArea';
export type kclRootState = ReturnType<typeof store.getState>;
export const store = configureStore({
    reducer: {
        form: formReducer,        
        glovesSelector: glovesSelectorReducer,
        [getConfigApi.reducerPath]: getConfigApi.reducer,      
        [getChemicalsApi.reducerPath]: getChemicalsApi.reducer,
        [getStyleNumbersApi.reducerPath]: getStyleNumbersApi.reducer,
        [getPermeationsApi.reducerPath]: getPermeationsApi.reducer,       
        [facetApi.reducerPath]: facetApi.reducer,
        [infoAreaApi.reducerPath]: infoAreaApi.reducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({ immutableCheck: false}).concat(getConfigApi.middleware).concat(getChemicalsApi.middleware).concat(getPermeationsApi.middleware).concat(facetApi.middleware).concat(infoAreaApi.middleware).concat(getStyleNumbersApi.middleware),
});
setupListeners(store.dispatch);